export function GuidesSectionLoading() {
  return (
    <section className="py-16 sm:py-20 lg:py-24 font-outfit bg-white w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Grid Skeleton */}
        <div className="space-y-12">
          <div className="grid grid-cols-[repeat(auto-fill,minmax(min(100%,300px),1fr))] gap-6 lg:gap-8 w-full">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="flex flex-row bg-white max-w-[545px]">
                {/* Content Skeleton */}
                <div className="p-6 flex flex-col gap-2 justify-between flex-1">
                  <div className="flex flex-col gap-2">
                    {/* Title */}
                    <div className="space-y-2 mb-2">
                      <div className="h-5 w-full rounded bg-gray-200 animate-pulse" />
                      <div className="h-5 w-4/5 rounded bg-gray-200 animate-pulse" />
                    </div>

                    {/* Summary lines */}
                    <div className="space-y-2">
                      <div className="h-4 w-full rounded bg-gray-100 animate-pulse" />
                      <div className="h-4 w-full rounded bg-gray-100 animate-pulse" />
                      <div className="h-4 w-3/4 rounded bg-gray-100 animate-pulse" />
                    </div>
                  </div>

                  {/* Button Skeleton */}
                  <div className="mt-4 w-full">
                    <div className="h-9 w-full rounded-full bg-gray-200 animate-pulse" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination Skeleton */}
          <div className="flex items-center justify-end gap-3 pt-4">
            <div className="h-10 w-20 rounded-lg bg-gray-200 animate-pulse" />
            <div className="h-10 aspect-square rounded-full bg-gray-200 animate-pulse" />
            <div className="h-10 aspect-square rounded-full bg-gray-200 animate-pulse" />
          </div>
        </div>
      </div>
    </section>
  );
}
